document.addEventListener('DOMContentLoaded', () => {
  const privacyLinks = document.querySelectorAll('a[href*="#cookies"]');

  privacyLinks.forEach(privacyLink => {
    privacyLink.addEventListener('click', (event) => {
      event.preventDefault();

      if (window.UC_UI) {
        window.UC_UI.showSecondLayer();
      }
    });
  });
});

// uc_event is a custom event triggered by Usercentrics
// it needs to be configured in CMP V2 settings (Implementation -> Data Layer and Events -> Window Event)
window.addEventListener('uc_event', function (e) {
  window.consentDetail = e.detail;

  // Hide wishlist if Wishlist King consent is not granted
  if (e.detail && e.detail['Wishlist King'] !== true) {
    // Check if style already exists to avoid duplicates
    if (!document.getElementById('wishlist-hide-style')) {
      const style = document.createElement('style');
      style.id = 'wishlist-hide-style';
      style.textContent = '.wishlist-header-link { display: none !important; }';
      document.head.appendChild(style);
    }
  } else if (e.detail && e.detail['Wishlist King'] === true) {
    // Remove the style if consent is granted
    const existingStyle = document.getElementById('wishlist-hide-style');
    if (existingStyle) {
      existingStyle.remove();
    }
  }

  if (e.detail && e.detail.event == 'consent_status' && e.detail.type === 'explicit') {
    // Set Shopify tracking consent based on UC categories
    window.Shopify && window.Shopify.loadFeatures && window.Shopify.loadFeatures(
      [{
        name: 'consent-tracking-api',
        version: '0.1',
      }],
      () => {
        window.Shopify.customerPrivacy.setTrackingConsent(
          {
            "analytics": !!e.detail?.ucCategory?.functional,
            "marketing": !!e.detail?.ucCategory?.marketing,
            "preferences": !!e.detail?.ucCategory?.functional,
            "sale_of_data": !!e.detail?.ucCategory?.functional && !!e.detail?.ucCategory?.marketing
          },
          () => { }
        );
        window.Shopify.analytics.publish("consent", e.detail ?? {});
      }
    );


    if (window.initialConsentSet) {
      // If any consent is revoked, reload the page to "stop" the scripts
      if (
        Object.keys(e.detail).some(function (service) {
          return e.detail[service] === false;
        })
      ) {
        window.location.reload();
      }
    }

    window.initialConsentSet = true;
  }
});
